import { formatDate, formatDateISO } from '@helpers/date';
import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import FakeButton from '@stories/Components/Global/Buttons/FakeButton/FakeButton';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './ArticleCard.styles';
const ArticleCard = (props) => {
    const srcs = getSrcs(props.image, 640, 343, 6, props.site, 492 / 263);
    const sizes = props.isListing
        ? `${until(Device.MobileLarge)} 100vw, ${until(Device.TabletLarge)} 50vw, ${until(Device.Desktop)} 33vw, ${until(Device.ActualDesktop)} 25vw, 429px`
        : `${until(Device.MobileLarge)} 100vw, ${until(Device.Desktop)} 50vw, ${until(Device.ActualDesktop)} 25vw, 429px`;
    return (React.createElement(S.Wrapper, { "data-site": props.site },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.Container, { ...(props.cta
                    ? {
                        as: 'a',
                        href: props.cta.url,
                        target: props.cta.target,
                        'data-has-link': true,
                    }
                    : {}) },
                React.createElement(S.ImageContainer, null,
                    React.createElement(S.Image, { src: srcs[0].split(' ')[0], srcSet: srcs.join(','), sizes: sizes, alt: props.image?.altText ?? props.title, loading: "lazy" })),
                React.createElement(S.Date, { dateTime: formatDateISO(props.date) }, formatDate(props.date, 'dd MMM yyyy')),
                React.createElement(S.Title, null, props.title),
                props.summary && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.summary } }),
                props.cta && (React.createElement(S.LinkContainer, null,
                    React.createElement(FakeButton, { buttonType: 'link-alt', site: props.site }, props.cta.text)))))));
};
export default ArticleCard;
